export default {
    multiple_myeloma_population_1: 'Age 30+ at diagnosis',
    multiple_myeloma_population_2: 'Age 30-70 at diagnosis',
    multiple_myeloma_population_3: 'Age 70+ at diagnosis',
    multiple_myeloma_population_4: 'Treated with a daratumumab-containing regimen',
    multiple_myeloma_population_5:
        'Treated with a regimen not containing isatuximab or daratumumab',
    multiple_myeloma_population_6: 'Treated with an isatuximab-containing regimen',
    multiple_myeloma_population_7: 'US general population',
};
